import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n";

const EASE = [0.22, 1, 0.36, 1];

const COPY = {
  it: {
    kicker: "Property Management",
    title: "La tua casa merita un metodo, non soltanto un annuncio.",
    sub: "Hai una casa vacanza? OGStay la gestisce professionalmente: strategia, ospiti e operatività con standard da alta hôtellerie.",
    points: [
      "Analisi e valorizzazione dell'immobile",
      "Revenue management",
      "Gestione delle prenotazioni",
      "Housekeeping professionale",
      "Guest experience",
      "Manutenzione",
      "Rendicontazione trasparente",
      "Portale proprietari",
    ],
    cta: "Scopri la gestione OGStay",
  },
  en: {
    kicker: "Property Management",
    title: "Your home deserves a method, not just a listing.",
    sub: "Own a holiday home? OGStay manages it professionally: strategy, guests and operations with high-end hôtellerie standards.",
    points: [
      "Property analysis and enhancement",
      "Revenue management",
      "Booking management",
      "Professional housekeeping",
      "Guest experience",
      "Maintenance",
      "Transparent reporting",
      "Owner portal",
    ],
    cta: "Discover OGStay management",
  },
};

export default function HomePM() {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const c = COPY[lang];
  return (
    <section id="property-management" data-testid="home-pm-section" className="bg-navy py-24 text-white sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 34 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <p className="kicker text-sky">
            <span className="h-px w-10 bg-sky" />
            {c.kicker}
          </p>
          <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">{c.title}</h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/65 sm:text-lg">{c.sub}</p>
          <button
            data-testid="home-pm-cta"
            onClick={() => navigate("/servizi")}
            className="btn-primary mt-9"
          >
            {c.cta}
            <ArrowRight className="h-4 w-4" />
          </button>
        </motion.div>
        <div className="grid gap-3 sm:grid-cols-2">
          {c.points.map((p, i) => (
            <motion.div
              key={p}
              data-testid={`pm-point-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: EASE }}
              className="flex items-center gap-3 rounded-2xl bg-white/5 px-5 py-4 ring-1 ring-white/10"
            >
              <Check className="h-4 w-4 shrink-0 text-sky" strokeWidth={3} />
              <span className="text-sm font-semibold text-white/85">{p}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
